// $t(jisuzhajinhua.***)

// 基本玩法弹窗相关
const oGameRulesModal = {
    winMessage: {
        en: '{name} won {amount} in the Golden Flower Flagship Hall, that\'s amazing!',
        cn: '{name}在炸金花旗舰厅赢得{amount}，真是太厉害了!',
    },
    basicRules: {
        en: 'Basic Rules',
        cn: '基本玩法',
    },
    rule1: {
        en: 'The game requires 4-7 players, uses one deck of poker cards, totaling 52 cards (excluding jokers).',
        cn: '游戏人数为4-7人，使用一副扑克牌，共计52张(去掉大小鬼)。',
    },
    rule2: {
        en: 'Each game consists of 5 rounds. After completion, it will automatically start matching for the next round. If you disconnect or click the stop automatic button, matching will stop after the current game ends.',
        cn: '每局游戏由5轮组成，完成后自动开始匹配下一局，断开连接或点击停止自动按钮则本局游戏结束后停止匹配',
    },
    trialHall: {
        en: 'Trial Hall',
        cn: '体验厅',
    },
    startGame: {
        en: 'Start Game',
        cn: '开始游戏',
    },
    // 基础玩法详细内容
    basicGameplay: {
        en: '1.Basic Gameplay',
        cn: '1.基础玩法',
    },
    basicParagraphs: {
        en: [
            'After entering the game, the system automatically starts the round and will auto-match the next round.',
            'If disconnected, it exits after this round (5 rounds). Clicking stop will stop after this round.',
            'The game stops after the current round ends.',
            'Then directly compare hand strengths.',
            'The player with the highest hand wins this round; others lose.',
            'Losers pay the winner according to the settlement rules.',
            'Payout multipliers by hand are as follows:',
        ],
        cn: [
            '进入游戏后，系统自动开始对局并会自动匹配下局',
            '断开连接会在本轮（共5局）结束退出，点击停止',
            '游戏则在本局结束后停止',
            '然后直接开始比较大小',
            '牌型最大的玩家即为本局赢家，其他玩家为输家',
            '输家按结算规则向赢家赔付游戏币',
            '不同牌型对应赔付倍率如下表',
        ],
    },
    payoutTable: {
        en: [
            ['Three of a Kind', '40'],
            ['Straight Flush', '20'],
            ['Flush', '10'],
            ['Straight', '6'],
            ['Pair', '4'],
            ['High Card', '2'],
        ],
        cn: [
            ['豹子', '40'],
            ['顺金', '20'],
            ['金花', '10'],
            ['顺子', '6'],
            ['对子', '4'],
            ['单张', '2'],
        ],
    },
    cardType: {
        en: 'Card Type',
        cn: '牌型',
    },
    multiplier: {
        en: 'Multiplier',
        cn: '倍数',
    },
};

// 游戏相关文本
const oGameText = {
    round: {
        en: 'Round',
        cn: '局',
    },
    currentRound: {
        en: 'Round {current}/{total}',
        cn: '第{current}/{total}局',
    },
};

export const oJisuzhajinhuaLang = {
    ...oGameRulesModal,
    ...oGameText,
    // 结算规则
    settlementRules: {
        en: '4. Settlement Rules',
        cn: '4. 结算规则',
    },
    settlementRoomMinBet: {
        en: 'A: Room Minimum Bet',
        cn: 'A: 房间底注',
    },
    settlementMultiplier: {
        en: 'M: Multiplier corresponding to the winner\'s card type',
        cn: 'M: 赢家牌型对应的倍数',
    },
    settlementLoserCalculation: {
        en: 'Loser\'s Payout Calculation:',
        cn: '输家赔付计算:',
    },
    settlementLoserFormula: {
        en: 'Game coins lost by loser = A * M, game coins carried by the loser in this round, game coins carried by the winner in this round. Take the minimum of these three.',
        cn: '输家所输游戏币=A*M,输家本局携带游戏币,赢家本局身上携带游戏,三者中取最小值',
    },
    settlementLoserExample: {
        en: 'Example: For example: In a certain round, the minimum bet is 10, the winner\'s card type multiplier is 20, the loser carries 1000 game coins, the winner carries 100 game coins. Then the game coins lost by the loser = minimum of 200, 1000, 100, which is 100.',
        cn: '比如:某局底注10,赢家的牌型倍数为20,输家携带游戏币1000,赢家携带游戏币100,那么输家所输游戏币=200,1000,100中取最小值100',
    },
    settlementWinnerCalculation: {
        en: 'Winner\'s Winnings Calculation:',
        cn: '赢家盈利计算:',
    },
    settlementWinnerFormula: {
        en: 'Game coins won by winner = sum of all game coins lost by losers - rake',
        cn: '赢家所赢游戏币=所有输家所输游戏币相加-抽水',
    },
    settlementRakeInfo: {
        en: 'Rake: 5% of the winner\'s winnings',
        cn: '抽水:赢家所赢金额的5%',
    },
    settlementAntiMechanism: {
        en: 'Anti-Small-Bet-Big Mechanism:',
        cn: '防以小博大机制:',
    },
    settlementAntiDescription: {
        en: 'The amount of game coins brought into this round is the maximum amount of game coins that can be won from each loser in this round.',
        cn: '本局带入多少游戏币,本局从每个输家身上最多赢多少游戏币。',
    },
    settlementAntiExample: {
        en: 'Example: For example, if you bring 80 game coins into this round, and 3 losers lose money to you. Theoretically, you should get 300. But if you lose this round, you can only lose a maximum of 80. So, for fairness, you can only win a maximum of 80 from each loser in this round. Therefore, your actual profit before deducting rake is 3 * 80 = 240, not 300.',
        cn: '比如您本局带入80,有3个输家输钱给您。计算时你理论应得300.但假如本局您输了,最多只输80.所以为了公平起见,您本局最多也只能从每个输家身上赢80.所以您实际盈利扣除抽水前是3*80=240,而不是300',
    },
    // 匹配牌桌提示
    tip: {
        en: 'Tip',
        cn: '提示',
    },
    matchingTable: {
        en: 'Matching a table for you',
        cn: '正在为您匹配牌桌',
    },
    matchingTableDesc: {
        en: 'The game is about to start, please wait patiently',
        cn: '游戏即将开始，请耐心等待',
    },
    gameStarting: {
        en: 'Game starting soon ({second})',
        cn: '游戏即将开始 ({second})',
    },
    stopAfterCurrentRound: {
        en: 'Will stop automatically after this round',
        cn: '本局结束后自动停止游戏',
    },
    continueGame: {
        en: 'Continue Game',
        cn: '继续游戏',
    },
    autoRestartHint: {
        en: 'Automatically start matching after this round',
        cn: '本局结束后自动开启匹配',
    },
    cancel: {
        en: 'Cancel',
        cn: '取消',
    },
    stopGame: {
        en: 'Stop Game',
        cn: '停止游戏',
    },
};
